import { render, staticRenderFns } from "./premium-episodes.vue?vue&type=template&id=b6180ff0&scoped=true&"
import script from "./premium-episodes.vue?vue&type=script&lang=js&"
export * from "./premium-episodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6180ff0",
  null
  
)

export default component.exports